import { FC } from "react";
import ReactMarkdown from "react-markdown";
import { Box } from "@mui/material";

interface Props {
  content: string;
}

const MarkdownRenderer: FC<Props> = ({ content }) => {
  return (
    <Box
      sx={{
        "& h1, & h2, & h3, & h4, & h5, & h6": {
          fontFamily: "Source Sans Pro, sans-serif",
          fontWeight: 600,
          color: "#000",
          marginTop: "16px",
          marginBottom: "8px",
          "&:first-of-type": {
            marginTop: 0,
          },
        },
        "& h1": {
          fontSize: "20px",
        },
        "& h2": {
          fontSize: "18px",
        },
        "& h3": {
          fontSize: "16px",
        },
        "& h4, & h5, & h6": {
          fontSize: "14px",
        },
        "& p": {
          fontFamily: "Source Sans Pro, sans-serif",
          fontSize: "14px",
          lineHeight: 1.5,
          color: "#666",
          marginBottom: "12px",
          textAlign: "justify",
          "&:last-child": {
            marginBottom: 0,
          },
        },
        "& ul, & ol": {
          fontFamily: "Source Sans Pro, sans-serif",
          fontSize: "14px",
          lineHeight: 1.5,
          color: "#666",
          marginBottom: "12px",
          paddingLeft: "20px",
        },
        "& li": {
          marginBottom: "4px",
        },
        "& strong, & b": {
          fontWeight: 700,
          color: "#333",
        },
        "& em, & i": {
          fontStyle: "italic",
        },
        "& code": {
          backgroundColor: "#f5f5f5",
          padding: "2px 4px",
          borderRadius: "3px",
          fontSize: "13px",
          fontFamily: "monospace",
          color: "#d63384",
        },
        "& pre": {
          backgroundColor: "#f8f9fa",
          padding: "12px",
          borderRadius: "6px",
          overflow: "auto",
          marginBottom: "12px",
          "& code": {
            backgroundColor: "transparent",
            padding: 0,
            color: "#000",
          },
        },
        "& blockquote": {
          borderLeft: "4px solid #dee2e6",
          paddingLeft: "16px",
          margin: "16px 0",
          fontStyle: "italic",
          color: "#6c757d",
        },
        "& hr": {
          border: "none",
          borderTop: "1px solid #dee2e6",
          margin: "16px 0",
        },
        "& table": {
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "16px",
          fontSize: "14px",
        },
        "& th, & td": {
          border: "1px solid #dee2e6",
          padding: "8px 12px",
          textAlign: "left",
        },
        "& th": {
          backgroundColor: "#f8f9fa",
          fontWeight: 600,
          color: "#000",
        },
        "& a": {
          color: "#0066cc",
          textDecoration: "none",
          "&:hover": {
            textDecoration: "underline",
          },
        },
      }}
    >
      <ReactMarkdown>{content}</ReactMarkdown>
    </Box>
  );
};

export default MarkdownRenderer;